import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { CONNECT_FEATURE_KEY, ConnectState, connectReducer } from '@rcs/ers-connect/store';

export interface RootState {
  router: RouterReducerState;
  [CONNECT_FEATURE_KEY]: ConnectState;
}

/**
 * Connect is registered at the root rather than on its lazy route on purpose: a
 * feature registered by a lazy route is torn down with that route, and the point
 * of the Connect cache is to survive navigating away and back.
 */
export const reducers: ActionReducerMap<RootState> = {
  router: routerReducer,
  [CONNECT_FEATURE_KEY]: connectReducer,
};

export const metaReducers: MetaReducer<RootState>[] = !environment.production
  ? []
  : [];
